<template>
  <vue-dropzone
    id="dropzone"
    :awss3="awss3"
    ref="myVueDropzone"
    duplicateCheck
    :options="dropzoneOptions"
    @vdropzone-s3-upload-error="s3UploadError"
    @vdropzone-s3-upload-success="s3UploadSuccess"
    @vdropzone-file-added="s3FileAdded"
    @vdropzone-max-files-exceeded="maxFiles"
    @vdropzone-error="dropzoneError"
    @vdropzone-removed-file="removeImage"
  ></vue-dropzone>
</template>
<script>
import { IMPROVE_CONFIG } from "@/config.js";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { EventBus } from '@/event-bus.js';
export default {
  name: "DropZone",
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    type: {
      type: String,
      default: null
    },
    image: {
      type: Object,
      default: null
    },
    text: {
      type: String,
      default: "Click here to upload file"
    },
    accepted: {
      type: String,
      default: ""
    },
    maxFilesize: {
      type: Number,
      default: 10
    },
    clear: {
      type: Boolean,
      default: false
    },
    dropzoneId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      fileDetails: {},
      url: "",
      uploading: false,
      uploadedImage: null,
      loading: false,
      dropzoneOptions: {
        url: `${IMPROVE_CONFIG.API_URL}/nowhere`,
        uploadMultiple: false,
        // previewTemplate: dropzoneTemplate,
        addRemoveLinks: true,
        capture: true,
        params: {},
        maxFiles: 1,
        timeout: 9999999999,
        dictDefaultMessage: this.text,
        maxFilesize: this.maxFilesize,
        acceptedFiles: this.accepted,
        dictMaxFilesExceeded: "You can remove the existing uploaded file and try again.",
      },
      awss3: {
        signingURL: IMPROVE_CONFIG.API_URL + "/sign",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*"
        },
        params: {
          type: this.type
        },
        sendFileToServer: false,
        withCredentials: false
      },
      s3ErrorMessage: "File upload error",
      complex: null
    };
  },
  computed: {
    //existingImage() {
    //  return this.src != null ? true : false;
    //},
    propSrc() {
      return this.image != null ? this.image.url : null;
    },
    src() {
      return this.uploadedImage != null ? this.uploadedImage : this.propSrc;
    },
    courseLoaded() {
      return this.$store.getters.dropzoneLoaded(this.dropzoneId);
    }
  },
  watch: {
    //url: function(newValue, oldValue) {
    //  this.$store.dispatch("setS3Url", newValue);
    //},
    //fileDetails: function(newValue, oldValue) {
    //  this.$store.dispatch("setFileDetails", newValue);
    //},
    courseLoaded: function(newValue, oldValue) {
      if (newValue && this.image) {
        this.$refs.myVueDropzone.manuallyAddFile(
          {
            size: this.image.file_size,
            name: this.image.original_name,
            type: this.image.mime_type
          },
          this.image.url
        );
        document.getElementById('dropzone').className += ' dz-max-files-reached';
        this.$store.dispatch("setS3Url", this.image.url);
        this.$store.dispatch("setFileDetails", {
          size: this.image.file_size,
          name: this.image.original_name,
          type: this.image.mime_type
        });

        if (this.type === 'header-email-logo') {
          this.$store.dispatch("setHeaderS3Url", this.image.url);
          this.$store.dispatch("setEmailHeaderLogo", this.image.url);
          this.$store.dispatch("setHeaderFileDetails", {
          size: this.image.file_size,
          name: this.image.original_name,
          type: this.image.mime_type
        });
       }
       if (this.type === 'footer-email-logo') {
          this.$store.dispatch("setFooterS3Url", this.image.url);
          this.$store.dispatch("setEmailFooterLogo", this.image.url);
          this.$store.dispatch("setFooterFileDetails", {
          size: this.image.file_size,
          name: this.image.original_name,
          type: this.image.mime_type
        });
       }
       
        this.$store.dispatch("setDropzoneLoaded", {id:this.dropzoneId, value: false});
        this.$store.dispatch("setS3Uploading", false);
      }
    }
  },
  mounted() {
    if (this.type === 'header-email-logo') {
        this.$store.dispatch("clearFile", "header")
    }else if(this.type === 'footer-email-logo'){
        this.$store.dispatch("clearFile", "footer")
    }else{
        this.$store.dispatch("clearFile");
    }
    this.$store.dispatch("setDropzoneLoaded", {id:this.dropzoneId, value: false});
  },
  methods: {
    maxFiles(file) {
      this.$refs.myVueDropzone.removeFile(file);
    },
    dropzoneError(file, msg) {
      msg = msg.replace('canceled','cancelled')
      this.$snotify.error(msg);
      this.$refs.myVueDropzone.removeFile(file);
    },
    init: function() {
      this.on("addedfile", function(file) {
        if (this.files.length > 1) {
          this.removeFile(this.files[0]);
        }
      });
    },
    removeImage() {
      //TODO - REMOVE
      //this.fileDetails = {};
      //this.url = "";
      document.getElementById('dropzone').className += ' enableMax';
      if (this.type === 'header-email-logo') {
        this.$store.dispatch("clearFile", "header")
      }else if(this.type === 'footer-email-logo'){
        this.$store.dispatch("clearFile", "footer")
      }else{
        this.$store.dispatch("clearFile");
      }
    },
    s3UploadSuccess(s3ObjectLocation) {
      let url = decodeURIComponent(s3ObjectLocation);
      this.$store.dispatch("setS3Url", url);
      this.$store.dispatch("setS3Uploading", false);

       if (this.type === 'header-email-logo') {
          this.$store.dispatch("setHeaderS3Url", url);
       }
       if (this.type === 'footer-email-logo') {
          this.$store.dispatch("setFooterS3Url", url);
       }

      EventBus.$emit('FILE_UPLOADED');
    },
    s3UploadError(errorMessage) {
      this.$snotify.error(errorMessage);
      this.uploading = false;
    },
    s3FileAdded(file) {
      document.getElementById('dropzone').classList.remove('enableMax');
      this.$store.dispatch("setS3Uploading", true);
      let fileDetails = {
        size: file.size,
        name: file.name,
        type: file.type
      };
      this.$store.dispatch("setFileDetails", fileDetails);

      setTimeout(() => {
        if (this.type === 'header-email-logo') {
          if(file.dataURL)
            this.$store.dispatch("setEmailHeaderLogo", file.dataURL);
          this.$store.dispatch("setHeaderFileDetails", fileDetails);
        }
        if (this.type === 'footer-email-logo') {
          if(file.dataURL)
            this.$store.dispatch("setEmailFooterLogo", file.dataURL);
          this.$store.dispatch("setFooterFileDetails", fileDetails);
        }
      }, 500);

    }
  }
};
</script>
